module.exports = __webpack_public_path__ + "static/media/blueDrop.309115b3.svg";